import { z } from 'zod';
/**
 * Lo que el monitor muestra de la entrega SAP del middleware (F25, decision C,
 * `docs/entrega-sap-despues-de-janis.md`): las entregas recientes y lo que F3
 * resta de cada posicion mientras una entrega no se registra (condicion 1).
 *
 * Contrato NUESTRO hacia la UI de monitoreo: estricto. Solo usuarios
 * autorizados (la API exige sesion).
 */
/** Los estados de una entrega (`sap_delivery.status`), en el orden en que avanza. */
export const MIDDLEWARE_DELIVERY_STATUSES = [
    'planned',
    'posting',
    'posted',
    'rejected',
    'cancelled',
    'cancelled_in_sap',
    'requires_return',
];
export const middlewareDeliveryStatusSchema = z.enum(MIDDLEWARE_DELIVERY_STATUSES);
/** Una linea de la entrega, contra la factura de reserva, en unidades de SAP. */
export const middlewareDeliveryLineViewSchema = z
    .object({
    baseLine: z.number().int().nonnegative(),
    itemCode: z.string(),
    warehouseCode: z.string().nullable(),
    quantity: z.number().nonnegative(),
    /** `false` en el `DESPACHO`: no resta en F3. */
    inventoryItem: z.boolean(),
})
    .strict();
/** Una entrega del middleware, como la ve el monitor. */
export const middlewareDeliveryViewSchema = z
    .object({
    id: z.string().uuid(),
    /** `MW_DELIV_<id>`: lo que se busca en `Comments` en SAP. */
    key: z.string(),
    janisOrderId: z.string(),
    status: middlewareDeliveryStatusSchema,
    reserveInvoiceDocEntry: z.number().int(),
    /** `YYYY-MM-DD`. */
    docDate: z.string(),
    sapDocEntry: z.number().int().nullable(),
    sapDocNum: z.number().int().nullable(),
    sapSeries: z.number().int().nullable(),
    attempts: z.number().int().nonnegative(),
    lastError: z.string().nullable(),
    /** Desde cuando F3 la resta; `null` antes del descuento de Janis. */
    discountSeenAt: z.string().datetime({ offset: true }).nullable(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
    lines: z.array(middlewareDeliveryLineViewSchema),
})
    .strict();
/** Lo que F3 resta de una posicion: las entregas sin registrar con el descuento visto. */
export const middlewareDeliveryPendingPositionSchema = z
    .object({
    warehouseCode: z.string(),
    itemCode: z.string(),
    quantity: z.number().positive(),
})
    .strict();
export const middlewareDeliveryOverviewSchema = z
    .object({
    /** `MW_SAP_DELIVERY_ENABLED`. */
    enabled: z.boolean(),
    /** Las mas recientes primero. */
    deliveries: z.array(middlewareDeliveryViewSchema),
    pending: z.array(middlewareDeliveryPendingPositionSchema),
})
    .strict();
/** Rutas de la API (bajo el prefijo `/api`). */
export const MIDDLEWARE_DELIVERY_PATHS = {
    overview: '/sap-deliveries',
};
//# sourceMappingURL=middleware-delivery-monitor.js.map